import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Hashim Noor </span>
            from <span className="purple"> Islamabad, Pakistan.</span>
            <br />
            I am currently employed as a Web developer at Octaloop Technologies.
            <br />
            I have completed <span className="purple">BS Computer Science</span>  from (FUUAST) Islamabad
            Pakistan.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight />Play Cricket
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading Books
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Hashim</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
